import {useContext} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import AtomCard from '@s-ui/react-atom-card'
import AtomImage from '@s-ui/react-atom-image'
import Context from '@s-ui/react-context'
import {
  imageUrlAdapterImageTypes,
  imageUrlAdapterTransformTypes,
  useImageUrlAdapter
} from '@adv-mt/mt-hook-use-image-url-adapter'

import CardThumbnailContent from './content.js'
import {
  ASPECT_RATIOS,
  BASE_CLASS,
  BASE_CLASS_MEDIA,
  DEFAULT_ALT,
  DEFAULT_PHOTO,
  DEFAULT_WIDTH,
  SIZES
} from './settings.js'

// eslint-disable-next-line react/prop-types
const AtomCardMedia = ({imageUrl, aspectRatio = ASPECT_RATIOS.FULL_SCREEN, imageAlt = DEFAULT_ALT}) => {
  const atomImageClass = `sui-AtomImage-image ${BASE_CLASS_MEDIA}-thumbnailImage`

  const mediaClass = cx(BASE_CLASS_MEDIA, {
    [`${BASE_CLASS_MEDIA}--full-screen`]: aspectRatio === ASPECT_RATIOS.FULL_SCREEN,
    [`${BASE_CLASS_MEDIA}--wide-screen`]: aspectRatio === ASPECT_RATIOS.WIDE_SCREEN,
    [`${BASE_CLASS_MEDIA}--full-frame`]: aspectRatio === ASPECT_RATIOS.FULL_FRAME
  })

  return (
    <div className={mediaClass}>
      <div className={`${BASE_CLASS_MEDIA}-thumbnail`}>
        <AtomImage className={atomImageClass} src={imageUrl} alt={imageAlt} />
      </div>
    </div>
  )
}

const CardThumbnail = props => {
  const {domain} = useContext(Context)
  const config = domain.get('config')
  const urlStatics = config.get('urlStatics')
  const defaultPhotoSrc = `${urlStatics}${DEFAULT_PHOTO}`

  const {imageUrl = defaultPhotoSrc, onCardClick, url} = props
  const hasOnClickFn = Boolean(onCardClick)
  const imageWidth = DEFAULT_WIDTH
  const getImagesUrlsAdapted = useImageUrlAdapter()
  const {
    images: [imageUrlOptimized]
  } = getImagesUrlsAdapted({
    images: [{src: imageUrl}],
    options: {
      imageWidth,
      imageType: imageUrlAdapterImageTypes.THUMBNAIL,
      transformType: imageUrlAdapterTransformTypes.DEVICE_CROP
    }
  })

  const handleClick = e => {
    if (!hasOnClickFn) return
    e.preventDefault()
    onCardClick()
  }
  const media = () => (
    <AtomCardMedia imageUrl={imageUrlOptimized?.src} aspectRatio={props.aspectRatio} imageAlt={props.imageAlt} />
  )

  const content = () => <CardThumbnailContent {...props} />

  return (
    <a className={BASE_CLASS} href={url} onClick={handleClick}>
      <AtomCard content={content} media={media} vertical />
    </a>
  )
}

CardThumbnail.displayName = 'CardThumbnail'
CardThumbnail.propTypes = {
  aspectRatio: PropTypes.oneOf(Object.values(ASPECT_RATIOS)),
  badgeText: PropTypes.string,
  caption: PropTypes.string,
  ctaText: PropTypes.string,
  description: PropTypes.string,
  descriptionHighlight: PropTypes.string,
  descriptionSize: PropTypes.string,
  imageAlt: PropTypes.string,
  imageUrl: PropTypes.string,
  isLabelSpaceReserved: PropTypes.bool,
  label: PropTypes.string,
  labelIcon: PropTypes.node,
  hasLabelStrikethrough: PropTypes.bool,
  onCardClick: PropTypes.func,
  onCtaClick: PropTypes.func,
  size: PropTypes.oneOf(Object.values(SIZES)),
  title: PropTypes.string,
  url: PropTypes.string
}

export default CardThumbnail

export {SIZES as cardThumbnailSizes}
export {ASPECT_RATIOS as cardThumbnailAspectRatios}
